import { privateAxiosIntance } from "../../Config/axios";
import { protectedRoutes } from "../../Config/urls";

export const getSubSubMenu = () => {
  try {
    const response = privateAxiosIntance.get(protectedRoutes.subSubManu);
    return response;
  } catch (error) {
    throw error;
  }
};
